import React from 'react'

import classNames from 'classnames'

interface Props {
  label: string
  href: string
  colorClass?: string
  noSpacingAfter?: boolean
}

const MenuItem: React.FC<Props> = ({ label, href, colorClass, noSpacingAfter }: Props) => {
  return (
    <a
      title={label}
      href={href}
      className={classNames(
        'px-2.5 py-1.5 text-md font-normal rounded-sm hover:bg-gray-highlight dark:hover:bg-gray-highlight-dm',
        colorClass,
        {
          'mb-2': !noSpacingAfter,
        }
      )}>
      {label}
    </a>
  )
}

MenuItem.defaultProps = {
  colorClass: 'text-black dark:text-gray',
}

export default MenuItem
